const PHONE_EN = '1-800-346-9140';
const PHONE_ES = '1-800-411-3222';

function replacePhoneNumbers(from, to) {
  const walker = document.createTreeWalker(
    document.body,
    NodeFilter.SHOW_TEXT,
    null
  );

  const regex = new RegExp(from.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g');
  let node;

  while ((node = walker.nextNode())) {
    if (regex.test(node.nodeValue)) {
      node.nodeValue = node.nodeValue.replace(regex, to);
      regex.lastIndex = 0;
    }
  }
}

function replaceTelHrefs(from, to) {
  const fromDigits = from.replace(/\D/g, '');
  const toDigits = to.replace(/\D/g, '');

  document.querySelectorAll(`a[href="tel:${from}"], a[href="tel:${fromDigits}"]`).forEach((el) => {
    // Preserve whichever format was used
    el.href = el.href.includes(fromDigits) && !el.href.includes('-')
      ? `tel:${toDigits}`
      : `tel:${to}`;
  });
}

function handleLangChange(lang) {
  if (lang === 'es') {
    replacePhoneNumbers(PHONE_EN, PHONE_ES);
    replaceTelHrefs(PHONE_EN, PHONE_ES);
  } else {
    replacePhoneNumbers(PHONE_ES, PHONE_EN);
    replaceTelHrefs(PHONE_ES, PHONE_EN);
  }
}

// Run once on load in case WeGlot already set the lang before this script runs
if (document.documentElement.lang === 'es') {
  handleLangChange('es');
}

// Watch for WeGlot switching the lang attribute
const observer = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    if (mutation.attributeName === 'lang') {
      handleLangChange(document.documentElement.lang);
    }
  }
});

observer.observe(document.documentElement, { attributes: true, attributeFilter: ['lang'] });
